

import React, { useState } from "react";

const faqs = [
  {
    question: "I filled out the questionnaire. How can I contact my therapist?",
    answer:
      "Based on your answers to the questionnaire, you will be matched with the most suitable online therapist. You can contact your therapist by logging into the MindTherapyCounselling mobile application or web portal. You may also schedule a free 15-minute welcome video call.",
  },
  {
    question:
      "I would like to have a welcoming video call with my therapist before starting the sessions. How can I make an appointment?",
    answer:
      "You can make a welcome video call appointment through our platform after logging in to your account.",
  },
  {
    question: "I have decided to start the sessions. How do I make the payment?",
    answer:
      "Payments can be made securely through our online platform using your preferred method.",
  },
  {
    question: "How can I join the online therapy and counseling sessions?",
    answer:
      "After matching with a therapist, you will receive session links via email or app notifications.",
  },
  {
    question: "What kinds of therapists are there at MindTherapyCounselling?",
    answer:
      "We have licensed clinical psychologists, counselors, and therapists specialized in various fields.",
  },
  {
    question:
      "I work full-time. Is it possible to get services in the evenings or on weekends?",
    answer:
      "Yes, many of our therapists offer flexible scheduling, including evenings and weekends.",
  },
  {
    question:
      "How do you ensure the privacy of personal data and the security of video calls?",
    answer:
      "All data and calls are end-to-end encrypted, and we comply with international data protection regulations.",
  },
  {
    question: "In what cases should MindTherapyCounselling not be used?",
    answer:
      "MindTherapyCounselling is not a crisis service. In urgent situations, please contact emergency services in your area.",
  },
  {
    question: "How can I contact you?",
    answer:
      "You can reach us via the contact form on our website or email support@mindtherapycounselling.com.",
  },
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="max-w-4xl mx-auto p-4 md:p-6 min-h-[80vh] flex flex-col justify-start font-roboto mt-24 md:mt-36">
      <h2 className="text-3xl font-bold mb-6">FAQs</h2>
      <ul className="divide-y divide-gray-300">
        {faqs.map((faq, index) => (
          <li
            key={index}
            className="py-4 cursor-pointer border-b border-gray-200 transition-all duration-300"
            onClick={() => toggleFAQ(index)}
          >
            <div className="flex items-center justify-between">
              <span className="font-semibold text-lg text-gray-800">
                {faq.question}
              </span>
              <span className="text-gray-500">
                {activeIndex === index ? "−" : "+"}
              </span>
            </div>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                activeIndex === index ? "max-h-96 opacity-100 mt-2" : "max-h-0 opacity-0"
              }`}
            >
              <p className="text-sm text-gray-600">{faq.answer}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FAQ;
